


























import Component from 'vue-class-component'
import BaseError from './BaseError'
import {Prop} from 'vue-property-decorator'

@Component({})
export default class ErrorComponent extends BaseError {

    @Prop() errorMessage!: string

}
